export function formatCurrency(value) {
  if (typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)) {
    return '-';
  }
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatPercent(value) {
  if (typeof value !== 'number' || Number.isNaN(value) || !Number.isFinite(value)) {
    return '-';
  }
  const normalized = Math.abs(value);
  const formatted = normalized >= 100 ? normalized.toFixed(0) : normalized.toFixed(1);
  return `${formatted.replace('.', ',')}%`;
}
